import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (siteId: string) =>
    fetchPages<LocatairePermanentResponse>(
      'locatairesPermanent',
      config.ws.locatairePermanent.all + `?siteId=${siteId}`,
      'GET'
    ),
  get: (siteId: string, id: string) =>
    ws<LocatairePermanentResponse>(config.ws.locatairePermanent.get.replace('{id}', id) + `?siteId=${siteId}`, 'GET'),
}

export default api
